import React, { useState, useEffect} from 'react';
import parse from "html-react-parser";
import PropTypes from 'prop-types' ;
import { CONFIGURATION } from 'constants/apis';
import i18n from 'i18next';
import { Modal, Button } from 'Components';
import Fetch from 'helpers/fetch';
import './WarningMessageModal.css';

const WarningMessageModal = (props) =>{
  const [warningMessage, setWarningMesseag] =useState('');
  useEffect(() => {
    const url = `${CONFIGURATION}/WarningMessage?section=${props.section}`;
    Fetch.Get(url)
    .then(response => response.json())
    .then((data) => {
      
      setWarningMesseag(data.DataItem);
    })
      .catch(({ response }) => props.onAPIError(response));
  });

  return (
    <Modal show>
      <div className="warning-message-modal">
        <div className="warning-message-modal__container">
          {
            (props.section!=='newSubmission'&&props.section!=='newTemplate'&&props.section!=='newJobInJobsDetail')?
            parse(warningMessage):
            i18n.t('additionalAnalysis:ErrorMessageQuote')
                      }
          <div className="warning-message-modal__buttons">
            {(props.showCancelButton===undefined||props.showCancelButton)&&(
            <Button onClick={props.onCancel} className="button--primary">
              {(props.showProceedButton===undefined||props.showProceedButton)?i18n.t('common:Cancel'):i18n.t('common:Ok')}
            </Button>
           )}
            {(props.showProceedButton===undefined||props.showProceedButton)&&(
            <Button onClick={props.onProceed} className="button--primary">{i18n.t('common:Proceed')}</Button>
           )}

            
          </div>
        </div>
      </div>
    </Modal>
  );
}

WarningMessageModal.propTypes = {
  onProceed: PropTypes.func,
  onCancel: PropTypes.func,
  section: PropTypes.string,
  onAPIError: PropTypes.func,
  showCancelButton: PropTypes.bool,
  showProceedButton: PropTypes.bool,

  };

export default WarningMessageModal;



// WEBPACK FOOTER //
// ./src/components/WarningMessageModal/WarningMessageModal.jsx